import { render } from "./LeadsCreateAccount.vue?vue&type=template&id=1bc7ba90&scoped=true"
import script from "./LeadsCreateAccount.vue?vue&type=script&lang=js"
export * from "./LeadsCreateAccount.vue?vue&type=script&lang=js"

import "./LeadsCreateAccount.vue?vue&type=style&index=0&id=1bc7ba90&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc7ba90"]])

export default __exports__